/**
 * @generated SignedSource<<7e716009a833225fe5ee536b68f2037a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OutOfStoreListItem_salesAssociate$data = {
  readonly name: string | null;
  readonly avatar: {
    readonly url: string;
  } | null;
  readonly " $fragmentType": "OutOfStoreListItem_salesAssociate";
};
export type OutOfStoreListItem_salesAssociate$key = {
  readonly " $data"?: OutOfStoreListItem_salesAssociate$data;
  readonly " $fragmentSpreads": FragmentRefs<"OutOfStoreListItem_salesAssociate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutOfStoreListItem_salesAssociate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Avatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SalesAssociate",
  "abstractKey": null
};

(node as any).hash = "457c02d75e36af3cade2002c34325fcf";

export default node;
